<ng-container *ngIf="data.length !== 0">
  <div class="p-modal-menu02__title">
    <h2 class="p-modal-menu02__title-label" [innerHTML]="'label.chargeableMeal' | staticMsg"></h2>
    <ul class="c-inline-list01">
      <li class="c-inline-list01__item" [innerHTML]="'label.mealMenuDetail.chargeable' | staticMsg"></li>
      <li class="c-inline-list01__item" [innerHTML]="'label.ruleDetail.meal.chargeable' | staticMsg"></li>
    </ul>
  </div>
  <ul class="p-modal-menu02__list">
    <!--　有料機内食分表示 -->
    <li *ngFor="let charge of data; index as i" class="p-modal-menu02__list-item">
      <div *ngIf="charge.quota === 0" class="p-modal-menu02__list-text">
        <div class="p-modal-menu02__list-text-inner">
          <span class="p-modal-menu02__btn-label">{{ charge.disp }}</span>
          <span class="p-modal-menu02__btn-status" [innerHTML]="'label.soldOut' | staticMsg"></span>
        </div>
      </div>
      <!--　ボタンは在庫があるもののみ有効 -->
      <button
        id="meal-appplication-modal-select-charge-button1-{{ i }}"
        *ngIf="charge.quota !== 0"
        type="button"
        class="p-modal-menu02__btn p-modal-menu02__btn--arrow"
        (throttleClick$)="clickItem(charge)"
        aswThrottleClick
      >
        <span class="p-modal-menu02__btn-inner">
          <span class="p-modal-menu02__btn-label">{{ charge.disp }}</span>
          <span class="p-modal-menu02__btn-status p-modal-menu02__btn-status--em">
            <span
              *ngIf="charge.total !== 0"
              class="c-amount c-amount--price"
              [innerHTML]="charge.total | amountFormat : 'default' : charge.currencyCode"
            >
              <!--
              <span class="c-amount__unit c-amount__unit--fs20">¥</span>
              <span class="c-amount__num c-amount__num--fs20"></span>
              -->
            </span>
          </span>
        </span>
      </button>
    </li>
  </ul>
</ng-container>
